var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('LayoutBanner'),_c('div',{staticClass:"about min_cw ql-snow"},[_vm._m(0),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"con ql-editor",domProps:{"innerHTML":_vm._s(_vm.infoData.content)}})])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('h2',{staticClass:"title"},[_vm._v("关于我们")])])
}]

export { render, staticRenderFns }